<h2 mat-dialog-title i18n="Dialog Title@@duplicateFileDialogFileAlreadyExistsDialogTitle">File Already Exists</h2>

<mat-dialog-content>
	<p class="conflict-message" i18n="Text@@duplicateFileDialogFileNamedAlreadyExists">
		A file named <strong>{{ data.filename }}</strong> already exists in this folder.
	</p>

	<!-- File comparison (if existing file info available) -->
	<div class="file-comparison" *ngIf="data.existingFile">
		<div class="file-info existing">
			<mat-icon>description</mat-icon>
			<div class="details">
				<span class="label" i18n="Text@@duplicateFileDialogExistingFile">Existing file</span>
				<span class="size">{{ formatFileSize(data.existingFile.size) }}</span>
				<span class="date" *ngIf="data.existingFile.modifiedAt">
					{{ formatDate(data.existingFile.modifiedAt) }}
				</span>
			</div>
		</div>
		<div class="file-info new">
			<mat-icon>upload_file</mat-icon>
			<div class="details">
				<span class="label" i18n="Text@@duplicateFileDialogNewFile">New file</span>
				<span class="size">{{ formatFileSize(data.newFile.size) }}</span>
			</div>
		</div>
	</div>

	<!-- Simple message when no existing file info -->
	<div class="file-comparison simple" *ngIf="!data.existingFile">
		<div class="file-info new">
			<mat-icon>upload_file</mat-icon>
			<div class="details">
				<span class="label" i18n="Text@@duplicateFileDialogFileUpload">File to upload</span>
				<span class="size">{{ formatFileSize(data.newFile.size) }}</span>
			</div>
		</div>
	</div>

	<!-- Apply to all checkbox (only show if there are remaining conflicts) -->
	<mat-checkbox
		[(ngModel)]="applyToAll"
		*ngIf="data.remainingConflicts > 0"
		class="apply-to-all"
		i18n="Text@@duplicateFileDialogApplyAllRemainingConflict"
	>
		{data.remainingConflicts, plural, =1 {Apply to all 1 remaining conflict} other {Apply to all {{ data.remainingConflicts }} remaining
		conflicts}}
	</mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()" class="cancel-btn" i18n="Button Label@@duplicateFileDialogCancelButtonLabel">Cancel</button>
	<button mat-button (click)="resolve('skip')" class="skip-btn">
		<mat-icon>skip_next</mat-icon>
		<span i18n="Button Label@@duplicateFileDialogSkipButtonLabel">Skip</span>
	</button>
	<button mat-button (click)="resolve('keep-both')" class="keep-both-btn">
		<mat-icon>file_copy</mat-icon>
		<span i18n="Button Label@@duplicateFileDialogKeepBothButtonLabel">Keep Both</span>
	</button>
	<button mat-flat-button color="primary" (click)="resolve('replace')" class="replace-btn">
		<mat-icon>swap_horiz</mat-icon>
		<span i18n="Button Label@@duplicateFileDialogReplaceButtonLabel">Replace</span>
	</button>
</mat-dialog-actions>
